document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButton = document.getElementById('load-more');
  const articlesContainer = document.getElementById('blog-articles-container');

  if (loadMoreButton && articlesContainer) {
    loadMoreButton.addEventListener('click', function() {
      let currentPage = parseInt(this.getAttribute('data-current-page'));
      const totalPages = parseInt(this.getAttribute('data-total-pages'));
      const nextPage = currentPage + 1;
console.log(nextPage);
      if (nextPage <= totalPages) {
        fetch(`?page=${nextPage}`)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');
            const newArticles = doc.querySelectorAll('#blog-articles-container .col-lg-4');

            newArticles.forEach(article => {
              articlesContainer.appendChild(article);
            });

            if (nextPage < totalPages) {
              loadMoreButton.setAttribute('data-current-page', nextPage);
            } else {
              loadMoreButton.textContent = 'No More Posts';
              loadMoreButton.disabled = true;
            }
          })
          .catch(error => {
            console.error('Error loading more articles:', error);
            loadMoreButton.textContent = 'Error Loading Posts';
          });
      } else {
        loadMoreButton.textContent = 'No More Posts';
        loadMoreButton.disabled = true;
      }
    });
  }
});
